<button
    *ngFor="let button of buttons"
    [class]="'btn ' + button.type"
    [ngStyle]="button.custom_css"
    [style.border-radius]="button.border_radius ? button.border_radius : ''"
    [innerHTML]="button.label"
    (click)="buttonClick(button)"
></button>
